import React from 'react';

// Official price table — mirrors the official price chart (public/price.png) as the single source of truth.
// 4 vehicle classes × 6 services + a merged motorcycle row, matching the design image.
// Note: 예약 시스템(9차종 × 8서비스)과는 별도 — 예약 흐름은 기존 services.js 사용.
// 광택을 최우측 컬럼으로 배치(2026-06-30, 사장님 요청). 광택은 전 차종 35만 동일이며
// 세차·유막제거·발수코팅을 포함하므로 헤더에 보조설명 + 컬럼 강조로 구분한다.
const COLS = ['외부', '내부', '내·외부', '발수코팅', '유리막', '광택'];
const POLISH_SUB = '세차·유막제거·발수코팅 포함'; // 광택 컬럼 보조설명

// Cell values are display strings straight from the price chart image (만원 단위 · '~' 또는 상의 포함).
// 셀 순서는 COLS와 동일: 외부 · 내부 · 내·외부 · 발수코팅 · 유리막 · 광택(35만 일괄).
const ROWS = [
  { id: 'compact', label: '경차',       cells: ['2만~', '3만~', '5만~', '10만', '20만', '35만'] },
  { id: 'sedan',   label: '승용차',     cells: ['3만~', '4만~', '6만~', '10만', '25만', '35만'] },
  { id: 'suv',     label: 'SUV',        cells: ['3만~', '4만~', '7만~', '10만', '25만', '35만'] },
  { id: 'truck',   label: '특수차/탑차', cells: ['4만~', '6만~', '8만~', '5만~', '25만', '35만'] },
];

// 오토바이는 전 서비스 동일 시작가 (이미지에서 통합 셀로 표기).
const MOTORCYCLE_PRICE = '5만~';

export default function OfficialPriceTable() {
  return (
    <div className="opt-wrap">
      <div className="opt-note-top">
        모든 메뉴에 <strong style={{ color: 'var(--primary)' }}>고온 스팀이 기본</strong>으로 포함됩니다.
      </div>

      {/* Desktop / Tablet: full table */}
      <div className="opt-table-desktop">
        <table>
          <thead>
            <tr>
              <th style={{ textAlign: 'left' }}>차종</th>
              {COLS.map(c => (
                <th key={c} className={c === '광택' ? 'opt-th-polish' : undefined}>
                  {c === '광택'
                    ? <><span>광택</span><span className="opt-th-sub">{POLISH_SUB}</span></>
                    : c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(r => (
              <tr key={r.id}>
                <td className="opt-row-label">{r.label}</td>
                {r.cells.map((v, i) => (
                  <td key={COLS[i]} className={COLS[i] === '광택' ? 'opt-td-polish' : undefined}>
                    <span className="opt-cell-price">{v}</span>
                  </td>
                ))}
              </tr>
            ))}
            {/* 오토바이: 전 서비스 통합 시작가 — 라벨 좌측 고정 + 가격 표 정중앙 */}
            <tr>
              <td colSpan={COLS.length + 1} style={{ position: 'relative', textAlign: 'center' }}>
                <span
                  className="opt-row-label"
                  style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)' }}
                >
                  오토바이
                </span>
                <span className="opt-cell-price">{MOTORCYCLE_PRICE}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Mobile: card per vehicle */}
      <div className="opt-cards-mobile">
        {ROWS.map(r => (
          <div key={r.id} className="opt-card">
            <div className="opt-card-title">{r.label}</div>
            <div className="opt-card-grid">
              {r.cells.map((v, i) => (
                COLS[i] === '광택' ? (
                  <div key={COLS[i]} className="opt-card-item opt-card-item-polish">
                    <div className="opt-card-polish-head">
                      <span className="opt-card-label">광택</span>
                      <span className="opt-card-value">{v}</span>
                    </div>
                    <span className="opt-card-sub">{POLISH_SUB}</span>
                  </div>
                ) : (
                  <div key={COLS[i]} className="opt-card-item">
                    <span className="opt-card-label">{COLS[i]}</span>
                    <span className="opt-card-value">{v}</span>
                  </div>
                )
              ))}
            </div>
          </div>
        ))}
        {/* 오토바이 카드 — 전 서비스 통합 */}
        <div className="opt-card">
          <div className="opt-card-title">오토바이</div>
          <div className="opt-card-grid">
            <div className="opt-card-item">
              <span className="opt-card-label">전 서비스</span>
              <span className="opt-card-value">{MOTORCYCLE_PRICE}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="opt-note-bottom">
        {/* 광택 포함내역은 표 광택 컬럼/카드에 직접 표기(2026-06-30) → 하단 중복 줄 제거 */}
        <div>• 광택·디테일링 추가 작업은 <strong>차종별 상의</strong></div>
        <div>• 단위: 만원 · 부가세 별도</div>
        {/* '매장 문의'를 한 줄로, 전화번호는 그 아래 줄로 분리(사장님 요청, 2026-06-29).
            번호는 각각 nowrap으로 묶어 번호 중간은 안 끊기고, 화면이 아주 좁을 때만
            두 번호 사이에서 줄바꿈된다. */}
        <div>• 차종 분류가 애매한 경우 매장 문의</div>
        <div>
          <span style={{ whiteSpace: 'nowrap' }}>(010-3931-4528,</span>{' '}
          <span style={{ whiteSpace: 'nowrap' }}>010-5735-5920)</span>
        </div>
      </div>
    </div>
  );
}
